import axios, { AxiosHeaders } from "axios";

export function getAccessToken() {
  const name = "accessToken=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// Function to handle logout - will be set by the auth provider
let logoutHandler: (() => void) | null = null;

export function setLogoutHandler(handler: () => void) {
  logoutHandler = handler;
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_API,
});

instance.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken();
    if (accessToken) {
      if (!config.headers) {
        config.headers = {} as AxiosHeaders;
      }
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // If backend returns 401 (Unauthorized), automatically logout
    // BUT only if it's not a login request (login failures are expected)
    if (error.response?.status === 401 && logoutHandler) {
      const isLoginRequest = error.config?.url?.includes("/auth/login");

      if (!isLoginRequest) {
        console.log("Received 401 from backend, logging out user");
        logoutHandler();
        // Redirect to login page after logout
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
